import React from 'react';
import { RENT_MONTHLY_COST_PRESETS } from '../../config/constants';
import { formatExactMoney } from '../../data/countries';
import {
  filterNumericInput,
  buildRentMonthlyCostsApiBody,
  sumRentMonthlyCostItems,
  parseRentCostAmount,
} from '../../utils/submissions';

const RentMonthlyCostsFields = ({ form, setForm, disabled, idPrefix = "rent-costs", variant = "stacked" }) => {
  const preview = buildRentMonthlyCostsApiBody(form);
  const extras = sumRentMonthlyCostItems(preview.monthlyCosts?.items || []);
  const base = parseRentCostAmount(form.monthlyRent);
  const totalSummary = (extras || base) ? (
    <p className={`rent-monthly-costs-fields__total${variant === "compact" ? " rent-monthly-costs-fields__total--compact" : ""}`}>
      <span>Estimated total</span>
      <strong>{formatExactMoney(base + extras, form.country || "US")}/month</strong>
      {base > 0 ? (
        <small>
          rent {formatExactMoney(base, form.country || "US")} + costs {formatExactMoney(extras, form.country || "US")}
        </small>
      ) : null}
    </p>
  ) : null;

  if (variant === "compact") {
    return (
      <div className="rent-monthly-costs-fields rent-monthly-costs-fields--compact">
        <div className="rent-monthly-costs-fields__grid">
          {RENT_MONTHLY_COST_PRESETS.filter((preset) => preset.id !== "other").map((preset) => (
            <label key={preset.id} className="rent-monthly-costs-fields__cell">
              <span>{preset.label}</span>
              <input
                id={`${idPrefix}-${preset.id}`}
                type="text"
                inputMode="decimal"
                placeholder="$/mo"
                value={form[`rentCost_${preset.id}`] || ""}
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    [`rentCost_${preset.id}`]: filterNumericInput(e.target.value, { decimal: true })
                  }))
                }
                disabled={disabled}
              />
            </label>
          ))}
          <label className="rent-monthly-costs-fields__cell rent-monthly-costs-fields__cell--other">
            <span>Other</span>
            <div className="rent-monthly-costs-fields__other-row">
              <input
                id={`${idPrefix}-other-label`}
                placeholder="Label"
                value={form.rentCost_otherLabel || ""}
                onChange={(e) => setForm((prev) => ({ ...prev, rentCost_otherLabel: e.target.value }))}
                disabled={disabled}
              />
              <input
                id={`${idPrefix}-other`}
                type="text"
                inputMode="decimal"
                placeholder="$/mo"
                value={form.rentCost_other || ""}
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    rentCost_other: filterNumericInput(e.target.value, { decimal: true })
                  }))
                }
                disabled={disabled}
              />
            </div>
          </label>
        </div>
        {totalSummary}
      </div>
    );
  }

  return (
    <div className="rent-monthly-costs-fields">
      {RENT_MONTHLY_COST_PRESETS.map((preset) => (
        <div key={preset.id} className="form-row" style={{ alignItems: "flex-end" }}>
          <div className="form-group" style={{ flex: 1, marginBottom: preset.id === "other" ? "0.35rem" : undefined }}>
            <label htmlFor={`${idPrefix}-${preset.id}`}>{preset.label}</label>
            {preset.id === "other" ? (
              <input
                id={`${idPrefix}-other-label`}
                placeholder="Describe (e.g. parking, cleaning)"
                value={form.rentCost_otherLabel || ""}
                onChange={(e) => setForm((prev) => ({ ...prev, rentCost_otherLabel: e.target.value }))}
                disabled={disabled}
                style={{ marginBottom: "0.5rem" }}
              />
            ) : null}
            <input
              id={`${idPrefix}-${preset.id}`}
              type="text"
              inputMode="decimal"
              placeholder="Optional $/month"
              value={form[`rentCost_${preset.id}`] || ""}
              onChange={(e) =>
                setForm((prev) => ({
                  ...prev,
                  [`rentCost_${preset.id}`]: filterNumericInput(e.target.value, { decimal: true })
                }))
              }
              disabled={disabled}
            />
          </div>
        </div>
      ))}
      {totalSummary}
    </div>
  );
};

export default RentMonthlyCostsFields;
